import cloneDeep from 'lodash.clonedeep';

import { CreationRequestState } from '@core/store/creation-request/creation-request-reducer';
import { AppStoreState } from '@interfaces/app-store-state';

export const creationRequestSelector = (state: AppStoreState): CreationRequestState =>
  state && state.creationRequest ? cloneDeep(state.creationRequest) : null;
